module.exports = __webpack_public_path__ + "media/ko_kr_s4_YooJoon.cd92f3cb.mp3";